import * as React from "react";

function SvgMoneyBillWaveAltSolid(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M21.41 5.702C20.2 5.194 18.987 5 17.774 5c-3.849 0-7.697 1.948-11.546 1.948-.966 0-1.93-.122-2.896-.429a1.069 1.069 0 00-.323-.05A.994.994 0 002 7.463v9.914c0 .395.226.769.589.92 1.212.51 2.425.703 3.637.703 3.85 0 7.699-1.948 11.547-1.948.966 0 1.93.122 2.896.428.108.035.217.05.323.05A.994.994 0 0022 16.538V6.623c0-.395-.226-.769-.59-.921zM12 15c-1.381 0-2.5-1.344-2.5-3 0-1.657 1.12-3 2.5-3s2.5 1.343 2.5 3-1.12 3-2.5 3z"
        fill="currentColor"
      />
    </svg>
  );
}

const ForwardRef = React.forwardRef(SvgMoneyBillWaveAltSolid);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
